import React, { memo } from 'react'
import PatternFormat, { IPatternFormatProps } from 'transfix-ui/components/PatternFormat'

type TPickedProp = 'placeholder' | 'value' | 'disabled' | 'name'

export interface ITimeProps extends Pick<IPatternFormatProps, TPickedProp> {
  id: string
  label?: string
  dataTest?: string
  required?: boolean
  onChange: (formattedValue: string, name: string, id: string) => void
}

const isValidTime = (value: string): boolean => {
  return !!value && value.indexOf('_') < 0
}

/**
 * @deprecated Use <TimeInput /> in transfix-ui instead
 */
export const Time = memo<ITimeProps>(
  ({ dataTest, disabled, id, label, name = '', onChange, placeholder, required, value }) => {
    const timeChangeHandler: IPatternFormatProps['onValueChange'] = ({ formattedValue }) => {
      if (isValidTime(formattedValue)) {
        onChange(formattedValue, name, id)
      }
    }

    return (
      <>
        {label && (
          <label htmlFor={id} className={required ? 'required' : ''}>
            {label}
          </label>
        )}
        <PatternFormat
          type='text'
          displayType='input'
          format='##:##'
          placeholder={placeholder}
          onValueChange={timeChangeHandler}
          value={value}
          disabled={disabled}
          id={id}
          name={name}
          data-test={dataTest}
        />
      </>
    )
  }
)
